import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMachineTransfers(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].getMachineTransfers,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function createMachineTransfer(companyId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].createMachineTransfer,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function getMachineTransfer(companyId, transfersId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].getMachineTransfer,
		{
			urlParams: {
				companyId,
				transfersId,
			},
		},
	)
}

function patchMachineTransfer(companyId, transfersId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].patchMachineTransfer,
		{
			urlParams: {
				companyId,
				transfersId,
			},
			...data,
		},
	)
}

function putMachineTransfer(companyId, transfersId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].putMachineTransfer,
		{
			urlParams: {
				companyId,
				transfersId,
			},
			...data,
		},
	)
}

function deleteMachineTransfer(companyId, transfersId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_TRANSFERS,dtConfig[ModulesMap.MACHINE_TRANSFERS].deleteMachineTransfer,
		{
			urlParams: {
				companyId,
				transfersId,
			},
		},
	)
}

export default {
	getMachineTransfers,
	getMachineTransfer,
	patchMachineTransfer,
	putMachineTransfer,
	createMachineTransfer,
	deleteMachineTransfer,
}